import { makeStyles } from "@mui/styles";

export default makeStyles((theme) => ({
  body: {
    overflowX: "hidden"
  },
  footerDiv: {
    margin: "auto",
    display: "flex",
    justifyContent: "center",
    position: "relative",
    // height: "calc(100vh - 400px)",
    width: "100%"
    // [theme.breakpoints.down("sm")]: {
    //   height: "calc(100vh - 500px)",
    // },
  },
  homeWrap: {
    marginTop: "0px",
    padding: "0",
    [theme.breakpoints.down("xl")]: {
      padding: "0 0px 0 100px"
    },
        [theme.breakpoints.down("1600")]: {
      padding: "0 0px 0 0px"
    },
    [theme.breakpoints.down(1180)]: {
      padding: "0px 45px 0px 45px",
      margin: "8px",
      marginTop: "60px"
    },
    [theme.breakpoints.down(1440)]: {
      padding: "0 45px 0 45px"
    },
    [theme.breakpoints.down(1300)]: {
      padding: "0 45px 0 45px"
    },
    [theme.breakpoints.down(1550)]: {
      padding: "0 0px 0 0px"
    },
     [theme.breakpoints.down(1024)]: {
      padding: "0 2px 0 2px"
    },
     [theme.breakpoints.down(600)]: {
      marginTop: "0px !important",
    },

    "& .carousel-root": {
      height: "auto",
      width: "100%",
      padding: "0",
      margin: "0",

      "& .LazyLoad": {
        height: "100% !important",
        "& img,svg": {
          borderRadius: "0"
        }
      },
      "&  .MuiButtonBase-root": {
        "& img,svg": {
          width: "40px",
          [theme.breakpoints.down("md")]: {
            width: "20px"
          }
        }
      }
    },
    // "& a": {
    //   [theme.breakpoints.down("md")]: {
    //     display: "none",
    //   },
    // },

    // [theme.breakpoints.down("xl")]: {
    //   height: "calc(100vh - 280px)",
    // },
    [theme.breakpoints.down("lg")]: {
      // height: "calc(100vh - 280px)",
      height: "100%"
    },
    [theme.breakpoints.down("md")]: {
      // marginTop: "60px",
      marginLeft: "8px",
      marginRight: "8px",
      padding: "0"
    },

    "& .control-arrow": {
      "&:hover": {
        background: "transparent !important"
      }
    }
  },
  sliderImg: {
    width: "100%"
  },
  homeGameWrap: {
    padding: "0 100px 100px",
    [theme.breakpoints.up("lg")]: {
      padding: "0 50px 18px"
    },
    [theme.breakpoints.down("xl")]: {
      padding: "0 15px 18px"
    },
    [theme.breakpoints.down("md")]: {
      display: "none"
    }
  },
  btnPrimary: {
    background: theme?.palette?.primary2TextColor?.main,
    borderRadius: "5px",
    padding: "8px 30px",
    color: theme?.palette?.secondaryText?.[700],
    fontSize: "14px",
    fontWeight: "600",
    textTransform: "capitalize",
    display: "inline-block",
    textDecoration: "none",
    cursor: "pointer",
    "&:hover": {
      background: theme?.palette?.primaryBG?.[450],
      color: theme?.palette?.primaryText?.[100]
    }
  },

  bannerLink: {
    borderRadius: "5px",
    paddingBottom: "10px",
    color: theme?.palette?.primaryText?.[100],
    fontSize: "15px",
    fontWeight: "600",
    textTransform: "capitalize",
    display: "inline-block",
    textDecoration: "none",
    cursor: "pointer",
    textAlign: "center"
  },

  // gameOneCard: {
  //   position: "relative",
  //   padding: "0 10px",
  //   transition: "transform .4s",
  //   "& span": {
  //     position: "absolute",
  //     bottom: "10px",
  //     left: "50%",
  //     transform: "translate(-50%, -50%)",
  //   },

  // },

  gameCardBox: {
    borderRadius: "10px",
    display: "flex",
    flexDirection: "column",
    overflow: "auto",
    "& img,svg": {
      width: "100%",
      height: "auto"
    },
    "& .gameCardBoxText": {
      backgroundColor: theme?.palette?.secondaryBG?.main,
      padding: "6px",
      "& p": {
        fontSize: "20px",
        color: theme?.palette?.primaryText?.[100],
        fontWeight: "600",
        [theme.breakpoints.up("lg")]: {
          fontSize: "16px"
        },
        [theme.breakpoints.down("sm")]: {
          fontSize: "12px"
        }
      }
    }
  },
  gameCardImg: {
    height: "370px",
    [theme.breakpoints.up("xl")]: {
      height: "420px"
    },
    [theme.breakpoints.down("lg")]: {
      height: "250px"
    },
    [theme.breakpoints.down("md")]: {
      height: "370px"
    },
    [theme.breakpoints.down("sm")]: {
      height: "160px"
    },
    "& img,svg": {
      height: "100%",
      width: "100%",
      objectFit: "cover"
    }
  },
  sliderPrev: {
    position: "absolute",
    top: "40%",
    left: "0",
    cursor: "pointer",
    zIndex: "1",
    [theme.breakpoints.down("md")]: {
      top: "40%"
    },
    [theme.breakpoints.down("sm")]: {
      top: "40%"
    },
    "& img,svg": {
      width: "67px",
      height: "67px"
    }
  },
  sliderNext: {
    position: "absolute",
    top: "40%",
    right: "0",
    cursor: "pointer",
    [theme.breakpoints.down("md")]: {
      top: "40%"
    },
    [theme.breakpoints.down("sm")]: {
      top: "40%"
    },
    "& img,svg": {
      width: "67px",
      height: "67px"
    }
  },
  // toolTipWrap: {
  //   // background:theme?.palette?.primary2TextColor?.main,
  //   fontSize: "24px",
  //   fontWeight: "600",
  //   color: theme?.palette?.secondaryText?.[700],
  // },
  toolTipWrap: {
    background: theme?.palette?.primary2TextColor?.main,
    fontSize: "10px",
    fontWeight: "600",
    color: theme?.palette?.secondaryText?.[700]
  },

  textDecorationNone: {
    textDecoration: "none"
  },

  toolTipArrow: {
    color: theme?.palette?.primary2TextColor?.main
  },
  sliderSkeleton: {
    width: "100%",
    [theme.breakpoints.up("xl")]: {
      height: "498px"
    },
    [theme.breakpoints.down("xl")]: {
      height: "369px"
    },
    [theme.breakpoints.down("lg")]: {
      height: "323px"
    },
    [theme.breakpoints.down(1000)]: {
      height: "270px"
    },
    [theme.breakpoints.down("md")]: {
      minHeight: "calc(100vh - 350px)",
      height: "calc(100vh - 350px)"
    },
    [theme.breakpoints.down("sm")]: {
      minHeight: "calc(100vh - 350px)",
      height: "calc(100vh - 350px)"
    }
  },
  sliderArrowImg: {
    width: "40px"
  },
  sliderwrap: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    rowGap: "1rem",
    "& .slick-dots": {
      position: "relative",
      display: "flex !important",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      listStyle: "none",
      height: "1rem",
      bottom: "0"
    },
    "& .slick-dots li": {
      width: "12px",
      height: "12px",
      borderRadius: "50%",
      backgroundColor: theme?.palette?.primaryText?.[200],
      opacity: 0.7
    },
    "& .slick-dots li button": {
      width: "100%",
      height: "100%",
      "&::before": {
        // eslint-disable-next-line quotes
        content: '""', // Content for ::before
        display: "block",
        width: "100%",
        height: "100%"
      }
    },

    // Corrected .slick-active selector for active state
    "& .slick-dots li.slick-active": {
      backgroundColor: theme?.palette?.primaryText?.[100],
      width: "14px",
      height: "14px"
    }
  },
  customImgWrap: {
    height: "100%"
  },
  homeBannerSection: {
    position: "relative",
    "& img,svg": {
      width: "100%",
      height: "100%"
    },
    [theme.breakpoints.down("md")]: {
      "& img": {
        width: "100%",
        height: "100%",
        borderRadius: "0 0 15px 15px"
      },
      "& .slick-slider": {
        height: "100%",
        "& .slick-list": {
          height: "100%",
          "& .slick-track": {
            height: "100%",
            "& .slick-slide": {
              height: "100%",
              "& div": {
                height: "100%"
              }
            }
          }
        }
      }
    }
  },
  skeletonWrapper: {
    position: "relative",
    height: "100%"
  },
  skeletonbanner: {
    [theme.breakpoints.up("xl")]: {
      height: "420px"
    },
    [theme.breakpoints.down("xl")]: {
      height: "370px"
    },
    [theme.breakpoints.down("lg")]: {
      height: "279px"
    },
    [theme.breakpoints.down(1000)]: {
      height: "250px"
    },
    [theme.breakpoints.down("md")]: {
      height: "370px"
    },
    [theme.breakpoints.down("sm")]: {
      height: "160px"
    }
  },
  slotgameContainer: {
    marginTop: "1rem",
    arrowbutton: {
      position: "absolute",
      top: "-30px",
      right: "30px !important",
      transform: "translate(-50%, -50%)",
      "& .slick-next:before": {
        display: "none"
      },
      "& button": {
        borderRadius: "10px",
        background: "#230E2F",
        minWidth: "28px",
        padding: "8px 8px"
      }
    },
    leftArrow: {
      right: "30px !important"
    },
    rightArrow: {
      right: "-10px !important"
    }
  }
}));
